import { DriversTable } from '@/components/DriversTable'
import { type Driver, DriverStatus, isDriverCarrierReady, useDrivers } from '@/models/driver'
import { FillFieldKey } from '@/models/fillApplication'
import type { BusinessOwner } from '@/models/user'
import { RosterKind } from './FillJumpProvider'
import { RosterFrame } from './RosterFrame'

// The confirm checks only look at active drivers.
function isComplete(driver: Driver): boolean {
  return driver.status !== DriverStatus.ACTIVE || isDriverCarrierReady(driver)
}

interface DriversRosterProps {
  orgId: string
  /** Offered as a new driver until one matches; once designated, they're on the roster already. */
  owner: BusinessOwner | null | undefined
}

export function DriversRoster({ orgId, owner }: DriversRosterProps) {
  const { drivers, isLoading } = useDrivers({ orgId, shouldFetchAllPages: true })
  const ownerAsDriver =
    owner && !owner.driverId
      ? {
          firstName: owner.firstName,
          lastName: owner.lastName,
          email: owner.email,
          mobile: owner.mobile ?? '',
          dob: owner.dob ?? '',
        }
      : null

  return (
    <RosterFrame
      title="Drivers"
      kind={RosterKind.DRIVERS}
      noun="driver"
      rows={drivers}
      isLoading={isLoading}
      isComplete={isComplete}
      fieldKey={FillFieldKey.DRIVERS}
      renderTable={(items, setItems, header) => (
        <DriversTable
          drivers={items}
          setDrivers={setItems}
          orgId={orgId}
          enforceCarrierRequired
          searchable
          ownerAsDriver={ownerAsDriver}
          hideOwnerToggle
          compact
          {...header}
        />
      )}
    />
  )
}
